import { z } from "zod";
//
// Primitives
//
const PrimitiveValue = z.number().or(z.boolean()).or(z.string());
const ArrayValue = z.array(z.string());
const ObjectValue = z.record(z.string());
export const DTOExporterPropertyValue = PrimitiveValue.or(ArrayValue).or(ObjectValue);
export const DTOExporterPropertyType = z.enum([
    "Enum",
    "Boolean",
    "String",
    "Number",
    "Array",
    "Object",
    "Code",
]);
//
// Property
//
const PropertyDefinitionBase = z.object({
    key: z.string(),
    title: z.string(),
    description: z.string(),
    category: z.string().optional(),
    dependsOn: z.record(z.boolean()).optional(),
});
export const DTOExporterPropertyDefinitionEnumOption = z.object({
    label: z.string(),
    description: z.string(),
});
export const DTOExporterPropertyDefinitionEnum = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Enum),
    options: z.record(DTOExporterPropertyDefinitionEnumOption),
    default: z.string(),
});
export const DTOExporterPropertyDefinitionBoolean = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Boolean),
    default: z.boolean(),
});
export const DTOExporterPropertyDefinitionString = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.String),
    default: z.string(),
    isMultiline: z.boolean().optional(),
});
export const DTOExporterPropertyDefinitionNumber = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Number),
    default: z.number(),
});
export const DTOExporterPropertyDefinitionArray = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Array),
    default: ArrayValue,
});
export const DTOExporterPropertyDefinitionObject = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Object),
    default: ObjectValue,
    allowedKeys: z
        .object({
        options: z.string().array(),
        type: z.string(),
    })
        .optional(),
    allowedValues: z
        .object({
        type: z.string(),
    })
        .optional(),
});
export const DTOExporterPropertyDefinitionCode = PropertyDefinitionBase.extend({
    type: z.literal(DTOExporterPropertyType.Enum.Code),
    language: z.string(),
    default: z.string(),
});
export const DTOExporterPropertyDefinition = z.discriminatedUnion("type", [
    DTOExporterPropertyDefinitionEnum,
    DTOExporterPropertyDefinitionBoolean,
    DTOExporterPropertyDefinitionString,
    DTOExporterPropertyDefinitionNumber,
    DTOExporterPropertyDefinitionArray,
    DTOExporterPropertyDefinitionObject,
    DTOExporterPropertyDefinitionCode,
]);
export const DTOExporterPropertyDefinitionsResponse = z.object({
    properties: DTOExporterPropertyDefinition.array(),
});
//
// Value
//
export const DTOExporterPropertyValueMap = z.record(DTOExporterPropertyValue);
